import React, {Component} from 'react';
import { BrowserRouter as  Router, Link  } from 'react-router-dom';

class Footer extends Component {
	
  	render() {
    	return (
            <footer className="clearfix no-print">
                <div className="pull-right">
                    Crafted with <i className="fa fa-heart text-danger"></i> by <a href="/" target="_blank">DMS</a>
                </div>
                <div className="pull-left">
                    <span id="year-copy"></span> &copy; <a href="/" target="_blank">Solapo Roofing</a>
                </div>
            </footer>
	    );
	}
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/inc/Footer.js